import React from 'react';

interface ArticleContentComponentProps {
    headerinnhold: JSX.Element | null;
    contentinnhold: JSX.Element | null;
}

export const ArticleContentComponent = (props: ArticleContentComponentProps): JSX.Element => {
    return (
        <article className="c-article c-article--modal">
            <div className="c-article__container c-article__container--modal">
                <h1 className="c-article__header c-article__header--modal">{props.headerinnhold}</h1>
                <div className="c-article__innhold">
                    <div className="c-article__content c-article__content--modal">{props.contentinnhold}</div>
                </div>
            </div>
        </article>
    );
};
